import { codeSystemUrl } from "@repo/fhir-systems";

/** Both offered options and recorded selections use the same stable coding system. */
export const EXAM_FINDING_OPTION_SYSTEM = codeSystemUrl("exam-finding-option");
